//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/alertTypes/views/main/lan/en';
import alertTypeDetails from 'Modules/alertTypes/views/main/.components/alertTypeDetails/lan/en';

locales = {
    ...locales,
    ...main,
    ...alertTypeDetails,
};

export default locales;